import { Check } from "lucide-react";

const bullets = [
    "Owns every vehicle we acquire — vans, RVs, and pilot cars",
    "Acquires and finances the fleet",
    "Leases the full fleet to Legacy Transit Solutions",
];

export default function HoldingCompany() {
    return (
        <section id="holding" data-testid="holding-section" className="py-24 px-6 bg-[#121620]">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-start">
                <div>
                    <p className="font-mono2 text-xs uppercase tracking-widest text-amber-500 mb-4">
                        Corporate Structure
                    </p>
                    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-6">
                        The holding company behind the fleet
                    </h2>
                    <p className="text-base text-slate-300 leading-relaxed max-w-xl">
                        Legacy GV Ventures sits above the operation. It owns the metal, carries the
                        financing, and leases every unit down to Legacy Transit Solutions — the
                        operator running the routes. Clean separation of assets from operations,
                        with one owner behind the entire fleet.
                    </p>
                </div>
                <div className="border border-white/10 bg-white/[0.03] rounded-lg p-8">
                    <p className="font-mono2 text-xs uppercase tracking-widest text-slate-400 mb-6">
                        What Legacy GV Ventures does
                    </p>
                    <ul className="space-y-5">
                        {bullets.map((b, i) => (
                            <li
                                key={b}
                                data-testid={`holding-company-bullet-${i + 1}`}
                                className="flex items-start gap-4"
                            >
                                <span className="mt-0.5 w-6 h-6 shrink-0 bg-amber-500/15 border border-amber-500/40 rounded-full flex items-center justify-center">
                                    <Check size={14} className="text-amber-500" />
                                </span>
                                <span className="text-base text-slate-200 leading-relaxed">{b}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
